import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../BBAdmin/Css/Tooltip.css';
import { faHomeAlt, faGear, faUserCircle, faPlus, faSearch, faUserGroup, faX, faSignOut, faBuilding, faBars } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from './context/themecontext';

const MHeader = ({ toggleSidebar }) => {
const navigate = useNavigate();
const { theme } = useTheme();
const isDarkMode = theme === "dark";


useEffect(() => {
}, []);


  const handleLogout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/vendor/vendor-logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': sessionStorage.getItem('token')
        }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        localStorage.removeItem('LoginData');
        sessionStorage.clear();


        navigate('/mfr');
      } else {
        console.error('Logout failed:', data.message);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const handleLogoClick = () => {
    navigate('/mfr/app/mdc');
  };

  
  return (
  <div className={`text-[0.8125rem] font-normal w-full h-full flex items-center justify-between overflow-hidden py-2 px-2 border-b transition-colors duration-300 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>

    {/* -------- Desktop Navbar -------- */}
    <div className="hidden md:flex w-full items-center justify-between">
      {/* Left side (Logo + Text) */}
      <div className="flex flex-row space-x-4">
        <div className="flex flex-row items-center px-3">
          {isDarkMode ? <img src={'/log_ht.png'} alt="Logo" className="h-8 w-50" /> : <img src={'/logo_h.png'} alt="Logo" className="h-8 w-50" /> }
{/*           <img
            className="w-8 h-8 cursor-pointer"
            src="/BB.png"
            alt="Brick Bucket Logo"
            onClick={handleLogoClick}
          />
          <p className={`text-xl ml-2 ${isDarkMode ? 'text-white' : 'text-black'}`}>Brickbucket</p> */}
        </div>
      </div>



    </div>

    {/* -------- Mobile Navbar -------- */}
    <div className="flex md:hidden w-full items-center justify-between">
      {/* Left side (Logo + Text) */}
      <div className="flex flex-row items-center ml-2">
      <img src={'/logo_h.png'} alt="Logo" className="h-8 w-35" />  
{/*         <img
          className="w-8 h-8 cursor-pointer"
          src="/BB.png"
          alt="Brick Bucket Logo"
          onClick={handleLogoClick}
        />
        <p className={`text-xl ml-2 ${isDarkMode ? 'text-white' : 'text-black'}`}>Brickbucket</p> */}
      </div>

      {/* Right side (Bars) */}
  <div className="flex items-center space-x-3 mr-2">
    <button onClick={toggleSidebar}>
      <FontAwesomeIcon icon={faBars} className={`text-2xl ${isDarkMode ? 'text-white' : 'text-black'}`} />
    </button>


  </div>
    </div>
  </div>
);

};

export default MHeader;
